import * as React from "react";
const SvgUnlockLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M22 7a5 5 0 0 0-10 0v2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-2V7a3 3 0 1 1 6 0v3a1 1 0 1 0 2 0zM4 11h12v9H4zm6 1.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6m-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0", clipRule: "evenodd" }));
export default SvgUnlockLine;
